<template>
  <div class="eoc-relative">
    <div class="eoc-fade"></div>
    <router-link :to="{ name: 'billing' }" class="btns eoc-button">
      {{ text }}
    </router-link>
  </div>
</template>

<script setup lang="ts">
/**
 * End-of-content button.
 *
 * Shows fade and a button to go to billing page.
 */
defineProps<{
  text: string
}>()
</script>

<style lang="scss" scoped>
.eoc-relative {
  position: relative;
  text-align: center;
}

.eoc-fade {
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff 80%);
  position: absolute;
  padding-top: 300px;
  width: 100%;
  bottom: 0;
  @media (max-width: $w-mobile-b) {
    padding-top: 400px;
  }
}

.eoc-button {
  position: relative;
}

.night-mode .eoc-fade {
  background: linear-gradient(180deg, rgba(55, 56, 60, 0), #2a2b2e 80%);

  @media only screen and (max-width: $w-tablet-s) {
    background: linear-gradient(180deg, rgba(55, 56, 60, 0), #1d1e20 80%);
  }
}
</style>
